import RestApiService from './rest.api.service';
;
;
class AuthAPIService extends RestApiService {
    constructor() {
        super();
        super.updateContextPath('auth');
    }
    register(payload) {
        return this.post('register', payload);
    }
    login(payload) {
        return this.post('verify', payload);
    }
}
;
const authApiService = new AuthAPIService();
export default authApiService;
